import React from "react";
import { Row, Col, Tabs } from "antd";
import Helmet from "react-helmet";
import { PUBLIC_URL } from "../../../config";
import JudgeCases from "./judge-cases";
import Overview from "./overview";
import InstitutionRate from "./key-metrics";
import CasesPerYear from "./cases-per-year";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  gutter: {
    marginTop: 16
  }
};

const JudgeDetail = props => {
  const { name } = props.router.params;
  const title = `PTAB Judge - ${name}`;
  const helmet = {
    title,
    meta: [
      {
        name: "keywords",
        content: `${name},PTAB Judge,Patent Trial and Appeal Board Judge,AIA,Administrative Patent Judge,Author Judge,Panel Judge`
      },
      {
        name: "description",
        content: `Cases and analytics for PTAB Judge ${name}.`
      }
    ],
    link: [
      {
        rel: "canonical",
        href: encodeURI(PUBLIC_URL + decodeURI(props.router.location.pathname))
      }
    ]
  };
  let { type } = props.location.query;
  if (type !== "author") type = "panel";
  const changeJudgeType = k =>
    props.router.push({
      pathname: props.location.pathname,
      query: k === "author" ? { type: k } : undefined
    });
  return (
    <div style={styles.body} key={type + name}>
      <Helmet {...helmet} />
      <Row>
        <Col span={24} lg={12}>
          <h2>{title}</h2>
        </Col>
        <Col span={24} lg={12}>
          <Tabs size="small" activeKey={type} onChange={changeJudgeType} tabBarStyle={{ margin: 0, float: "right" }}>
            <Tabs.TabPane key="panel" tab="As Panel Judge" />
            <Tabs.TabPane key="author" tab="As Author Judge" />
          </Tabs>
        </Col>
      </Row>
      <Overview name={name} type={type} style={styles.gutter} />
      <Row gutter={8}>
        <Col span={24} xl={12}>
          <InstitutionRate name={name} type={type} style={styles.gutter} />
        </Col>
        <Col span={24} xl={12}>
          <CasesPerYear name={name} type={type} style={styles.gutter} />
        </Col>
      </Row>
      <JudgeCases name={name} type={type} style={styles.gutter} />
    </div>
  );
};

export default JudgeDetail;
